import { createContext } from 'react';

export interface ModalContext {
  isOpen: boolean;
  onClose: () => void;
  onOpen: (content: React.ReactNode) => void;
  content?: React.ReactNode;
}
const defaultValue: ModalContext = {
  isOpen: false,
  onClose: () => {},
  onOpen: () => {},
  content: undefined,
};

export const ModalContext = createContext<ModalContext>(defaultValue);
